const cardFilled: object = {
  transparent: {
    backgroud: "bg-transparent",
    color: "text-gray-700",
    shadow: "shadow-none",
  },
  white: {
    backgroud: "bg-white",
    color: "text-gray-700",
  },
  "blue-gray": {
    backgroud: "bg-blue-gray-500",
    color: "text-white",
    shadow: "shadow-blue-gray-500/40",
  },
  gray: {
    backgroud: "bg-gray-500",
    color: "text-white",
    shadow: "shadow-gray-500/40",
  },
  brown: {
    backgroud: "bg-brown-500",
    color: "text-white",
    shadow: "shadow-brown-500/40",
  },
  "deep-orange": {
    backgroud: "bg-deep-orange-500",
    color: "text-white",
    shadow: "shadow-deep-orange-500/40",
  },
  orange: {
    backgroud: "bg-orange-500",
    color: "text-white",
    shadow: "shadow-orange-500/40",
  },
  amber: {
    backgroud: "bg-amber-500",
    color: "text-gray-700",
    shadow: "shadow-amber-500/40",
  },
  yellow: {
    backgroud: "bg-yellow-500",
    color: "text-gray-700",
    shadow: "shadow-yellow-500/40",
  },
  lime: {
    backgroud: "bg-lime-500",
    color: "text-gray-700",
    shadow: "shadow-lime-500/40",
  },
  "light-green": {
    backgroud: "bg-light-green-500",
    color: "text-white",
    shadow: "shadow-light-green-500/40",
  },
  green: {
    backgroud: "bg-green-500",
    color: "text-white",
    shadow: "shadow-green-500/40",
  },
  teal: {
    backgroud: "bg-teal-500",
    color: "text-white",
    shadow: "shadow-teal-500/40",
  },
  cyan: {
    backgroud: "bg-cyan-500",
    color: "text-white",
    shadow: "shadow-cyan-500/40",
  },
  "light-blue": {
    backgroud: "bg-light-blue-500",
    color: "text-white",
    shadow: "shadow-light-blue-500/40",
  },
  blue: {
    backgroud: "bg-blue-500",
    color: "text-white",
    shadow: "shadow-blue-500/40",
  },
  indigo: {
    backgroud: "bg-indigo-500",
    color: "text-white",
    shadow: "shadow-indigo-500/40",
  },
  "deep-purple": {
    backgroud: "bg-deep-purple-500",
    color: "text-white",
    shadow: "shadow-deep-purple-500/40",
  },
  purple: {
    backgroud: "bg-purple-500",
    color: "text-white",
    shadow: "shadow-purple-500/40",
  },
  pink: {
    backgroud: "bg-pink-500",
    color: "text-white",
    shadow: "shadow-pink-500/40",
  },
  red: {
    backgroud: "bg-red-500",
    color: "text-white",
    shadow: "shadow-red-500/40",
  },
};

export default cardFilled;
